<template>
	<div class="pagination">
		<div
			class="item-pagination first"
			v-if="current_page > 0"
			@click="paginationItem_click(1)"
		>Debut ...</div>
		<div
			class="item-pagination"
			v-for="index in indexes_display"
			:key="index"
			@click="paginationItem_click(index)"
			:class="current_page + 1 == index ? 'active': ''"
		>{{index}}</div>
		<div
			class="item-pagination last"
			v-if="current_page < nb_page - 1"
			@click="paginationItem_click(nb_page)"
		>... Fin</div>
	</div>
</template>

<script>
import { EventBus } from '@core/event-bus';
/**
 * Composant permettant d'afficher une pagination
 *
 * @version 1.0.0
 */
export default {
	name: 'pagination',
	props: {
		/**
		 * Le total d'éléments de la liste d'item à paginer
		 */
		total_posts: {
			type: Number,
			required: true,
		},
		/**
		 * Le nombre d'éléments par page
		 */
		per_page: {
			type: Number,
			default: 10,
		},
		/**
		 * Le nombre de page à afficher avant d'indiquer "Fin"
		 */
		pages_display: {
			type: Number,
			default: 6,
		},
	},

	data() {
		return {
			nb_page: 0,
			indexes_display: [],
			/**
			 * La page courrante
			 */
			current_page: 0,
			minMax: Math.floor(this.pages_display / 2),
		};
	},
	mounted() {
		this.nb_page = Math.floor(this.total_posts / this.per_page);
	},
	watch: {
		total_posts: function(total_posts, oldTotal_posts) {
			this.nb_page = Math.floor(total_posts / this.per_page);
			this.getIndexesDisplay();
		},
		current_page: function() {
			this.getIndexesDisplay();
		},
	},

	methods: {
		//on update le tableau d'index en fonction de current page
		getIndexesDisplay() {
			this.indexes_display = [];

			//si moins de deux page du début
			if (this.current_page < this.minMax) {
				for (let index = 1; index <= this.pages_display; index++) {
					this.indexes_display.push(index);
				}
				//si à deux pages de la fin
			} else if (this.current_page >= this.nb_page - this.minMax) {
				for (
					let index = this.nb_page - this.pages_display + 1;
					index <= this.nb_page;
					index++
				) {
					this.indexes_display.push(index);
				}
				//ni à deux pages du début ni à deux pages de la fin
			} else {
				for (
					let index = this.current_page - this.minMax + 1;
					index < this.current_page;
					index++
				) {
					this.indexes_display.push(index);
				}

				this.indexes_display.push(this.current_page);

				for (
					let index = this.current_page + 1;
					index <= this.current_page + this.minMax + 1;
					index++
				) {
					this.indexes_display.push(index);
				}
			}
		},
		paginationItem_click(index) {
			this.current_page = index - 1;
			EventBus.$emit('pagination_item-pagination_click', index);
		},
	},
};
</script>

<style lang="scss" scoped>
@import '~@scss/style.scss';

.pagination {
	display: flex;
	justify-content: center;
	align-items: center;
}

.item-pagination {
	display: flex;
	justify-content: center;
	align-items: center;
	position: relative;
	width: 35px;
	height: 35px;
	font-size: 15px;
	font-weight: bold;
	color: $mainColor;
	cursor: pointer;

	&::before {
		content: '';
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		width: 35px;
		height: 35px;
		border: solid 1px $secondaryColor;
		border-radius: 35px;
		opacity: 0;
		transition: all 0.3s ease-in-out;
	}

	&.active {
		&::before {
			opacity: 1;
		}
	}

	&.first,
	&.last {
		width: auto;
	}

	+ .item-pagination {
		margin-left: 10px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/global/Pagination.vue